(ns dre.pages.search.views
  (:require
   [dre.pages.search.views.dashboard :as dashboard]
   [dre.pages.search.views.widgets-menu :as widgets-menu]))


(defn view
  []
  [:<>
   [widgets-menu/view]
   [dashboard/view]])
